import { Collateral, CompanyProfile } from 'models';
import { CollateralHelpers } from 'helpers/CollateralHelpers';
import { CompanyHelpers } from 'helpers/CompanyHelpers';

import { useCollateral } from 'hooks/use-collateral';

export type CollateralItem = {
    key: string;
    title: string;
    collateral: Collateral;
    href: string;
};

const useCollateralItems = (
    company: Pick<CompanyProfile, 'id' | 'slug' | 'collateralOrder'>,
    fallbackData?: Collateral[],
) => {
    const { collateral, isLoading } = useCollateral(company, fallbackData);

    const items: CollateralItem[] = collateral.filter(CollateralHelpers.isViewable).map((item) => ({
        key: item.id,
        title: item.title,
        collateral: item,
        href: CompanyHelpers.urls.collateralItem(company.slug, item.id),
    }));

    return { items, isLoading };
};

export { useCollateralItems };
